export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center">
      {/* Full background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9990b13630076a26385b6d54901cc102.jpg"
          alt="Lotus Maternal Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/10"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-5 py-2 mb-8">
            <i className="ri-leaf-line text-green-300 text-sm"></i>
            <span className="text-white text-sm font-body font-medium tracking-wide">Holistic Doula Care for Every Family</span>
          </div>

          <h1 className="font-display text-7xl lg:text-8xl font-bold text-white leading-none mb-6">
            Lotus<br />
            <span className="text-amber-400" style={{ textShadow: '0 0 40px rgba(217,119,6,0.5)' }}>Maternal</span>
          </h1>

          <p className="font-body text-lg text-white/85 leading-relaxed max-w-xl mb-10">
            Providing compassionate, personalized care and support to all families throughout their fertility, pregnancy, birth, and postpartum journey. You deserve to feel <em>empowered, informed, and celebrated</em>.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollToSection('booking')}
              className="px-8 py-4 bg-amber-700 text-white font-body font-semibold rounded-full hover:bg-amber-800 hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer text-base"
            >
              Book Free Consultation
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="px-8 py-4 bg-white/15 backdrop-blur-sm border-2 border-white/60 text-white font-body font-semibold rounded-full hover:bg-white hover:text-neutral-charcoal transition-all whitespace-nowrap cursor-pointer text-base"
            >
              Our Services
            </button>
          </div>

          <div className="flex flex-wrap gap-8 mt-14">
            <div className="text-center">
              <div className="text-4xl font-display font-bold text-white">100+</div>
              <div className="text-sm font-body text-white/70 mt-1">Families Supported</div>
            </div>
            <div className="w-px bg-white/30"></div>
            <div className="text-center">
              <div className="text-4xl font-display font-bold text-white">24/7</div>
              <div className="text-sm font-body text-white/70 mt-1">Support Available</div>
            </div>
            <div className="w-px bg-white/30"></div>
            <div className="text-center">
              <div className="text-4xl font-display font-bold text-white">4.9★</div>
              <div className="text-sm font-body text-white/70 mt-1">Client Rating</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs font-body tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/60 text-xl"></i>
      </div>
    </section>
  );
}
